import { render, staticRenderFns } from "./IdealValShortcutComponent.vue?vue&type=template&id=22a23e32&"
import script from "./IdealValShortcutComponent.vue?vue&type=script&lang=js&"
export * from "./IdealValShortcutComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports